// GET list
export const GET_BRAND_SERVICE_STEPS_REQUESTED = 'brandServiceSteps/GET_BRAND_SERVICE_STEPS_REQUESTED';
export const GET_BRAND_SERVICE_STEPS_SUCCESS = 'brandServiceSteps/GET_BRAND_SERVICE_STEPS_SUCCESS';
export const GET_BRAND_SERVICE_STEPS_FAILURE = 'brandServiceSteps/GET_BRAND_SERVICE_STEPS_FAILURE';

// GET by id
export const GET_BRAND_SERVICE_STEP_BY_ID_REQUESTED = 'brandServiceSteps/GET_BRAND_SERVICE_STEP_BY_ID_REQUESTED';
export const GET_BRAND_SERVICE_STEP_BY_ID_SUCCESS = 'brandServiceSteps/GET_BRAND_SERVICE_STEP_BY_ID_SUCCESS';
export const GET_BRAND_SERVICE_STEP_BY_ID_FAILURE = 'brandServiceSteps/GET_BRAND_SERVICE_STEP_BY_ID_FAILURE';

// ADD
export const ADD_BRAND_SERVICE_STEP_REQUESTED = 'brandServiceSteps/ADD_BRAND_SERVICE_STEP_REQUESTED';
export const ADD_BRAND_SERVICE_STEP_SUCCESS = 'brandServiceSteps/ADD_BRAND_SERVICE_STEP_SUCCESS';
export const ADD_BRAND_SERVICE_STEP_FAILURE = 'brandServiceSteps/ADD_BRAND_SERVICE_STEP_FAILURE';

// UPDATE
export const UPDATE_BRAND_SERVICE_STEP_REQUESTED = 'brandServiceSteps/UPDATE_BRAND_SERVICE_STEP_REQUESTED';
export const UPDATE_BRAND_SERVICE_STEP_SUCCESS = 'brandServiceSteps/UPDATE_BRAND_SERVICE_STEP_SUCCESS';
export const UPDATE_BRAND_SERVICE_STEP_FAILURE = 'brandServiceSteps/UPDATE_BRAND_SERVICE_STEP_FAILURE';

// DELETE
export const DELETE_BRAND_SERVICE_STEP_REQUESTED = 'brandServiceSteps/DELETE_BRAND_SERVICE_STEP_REQUESTED';
export const DELETE_BRAND_SERVICE_STEP_SUCCESS = 'brandServiceSteps/DELETE_BRAND_SERVICE_STEP_SUCCESS';
export const DELETE_BRAND_SERVICE_STEP_FAILURE = 'brandServiceSteps/DELETE_BRAND_SERVICE_STEP_FAILURE';

// SORT
export const SORT_BRAND_SERVICE_STEPS_REQUESTED = 'brandServiceSteps/SORT_BRAND_SERVICE_STEPS_REQUESTED';
export const SORT_BRAND_SERVICE_STEPS_SUCCESS = 'brandServiceSteps/SORT_BRAND_SERVICE_STEPS_SUCCESS';
export const SORT_BRAND_SERVICE_STEPS_FAILURE = 'brandServiceSteps/SORT_BRAND_SERVICE_STEPS_FAILURE';

// Lookups
export const GET_ORDER_TYPE_MASTERS_REQUESTED = 'brandServiceSteps/GET_ORDER_TYPE_MASTERS_REQUESTED';
export const GET_ORDER_TYPE_MASTERS_SUCCESS = 'brandServiceSteps/GET_ORDER_TYPE_MASTERS_SUCCESS';
export const GET_ORDER_TYPE_MASTERS_FAILURE = 'brandServiceSteps/GET_ORDER_TYPE_MASTERS_FAILURE';

export const GET_REVENUE_CENTER_MASTERS_REQUESTED = 'brandServiceSteps/GET_REVENUE_CENTER_MASTERS_REQUESTED';
export const GET_REVENUE_CENTER_MASTERS_SUCCESS = 'brandServiceSteps/GET_REVENUE_CENTER_MASTERS_SUCCESS';
export const GET_REVENUE_CENTER_MASTERS_FAILURE = 'brandServiceSteps/GET_REVENUE_CENTER_MASTERS_FAILURE';

export const GET_JOB_TYPES_REQUESTED = 'brandServiceSteps/GET_JOB_TYPES_REQUESTED';
export const GET_JOB_TYPES_SUCCESS = 'brandServiceSteps/GET_JOB_TYPES_SUCCESS';
export const GET_JOB_TYPES_FAILURE = 'brandServiceSteps/GET_JOB_TYPES_FAILURE';

export const GET_SERVICE_STEP_RULE_TYPES_REQUESTED = 'brandServiceSteps/GET_SERVICE_STEP_RULE_TYPES_REQUESTED';
export const GET_SERVICE_STEP_RULE_TYPES_SUCCESS = 'brandServiceSteps/GET_SERVICE_STEP_RULE_TYPES_SUCCESS';
export const GET_SERVICE_STEP_RULE_TYPES_FAILURE = 'brandServiceSteps/GET_SERVICE_STEP_RULE_TYPES_FAILURE';

export const GET_SERVICE_STEP_INTERACTION_TYPES_REQUESTED = 'brandServiceSteps/GET_SERVICE_STEP_INTERACTION_TYPES_REQUESTED';
export const GET_SERVICE_STEP_INTERACTION_TYPES_SUCCESS = 'brandServiceSteps/GET_SERVICE_STEP_INTERACTION_TYPES_SUCCESS';
export const GET_SERVICE_STEP_INTERACTION_TYPES_FAILURE = 'brandServiceSteps/GET_SERVICE_STEP_INTERACTION_TYPES_FAILURE';

export const GET_BRAND_STORES_REQUESTED = 'brandServiceSteps/GET_BRAND_STORES_REQUESTED';
export const GET_BRAND_STORES_SUCCESS = 'brandServiceSteps/GET_BRAND_STORES_SUCCESS';
export const GET_BRAND_STORES_FAILURE = 'brandServiceSteps/GET_BRAND_STORES_FAILURE';

const initialState = {
  loading: false,
  loaded: false,
  error: false,
  brandServiceStepsList: [],
  brandServiceStepData: {},
  orderTypeMasterList: [],
  revenueCenterMasterList: [],
  jobTypesList: [],
  serviceStepRuleTypesList: [],
  serviceStepInteractionTypesList: [],
  storesList: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_BRAND_SERVICE_STEPS_REQUESTED:
    case GET_BRAND_SERVICE_STEP_BY_ID_REQUESTED:
    case ADD_BRAND_SERVICE_STEP_REQUESTED:
    case UPDATE_BRAND_SERVICE_STEP_REQUESTED:
    case DELETE_BRAND_SERVICE_STEP_REQUESTED:
    case SORT_BRAND_SERVICE_STEPS_REQUESTED:
    case GET_ORDER_TYPE_MASTERS_REQUESTED:
    case GET_REVENUE_CENTER_MASTERS_REQUESTED:
    case GET_JOB_TYPES_REQUESTED:
    case GET_SERVICE_STEP_RULE_TYPES_REQUESTED:
    case GET_SERVICE_STEP_INTERACTION_TYPES_REQUESTED:
    case GET_BRAND_STORES_REQUESTED:
      return {
        ...state, loading: true, loaded: false, error: false
      };

    case GET_BRAND_SERVICE_STEPS_SUCCESS:
      return {
        ...state, loading: false, loaded: true, error: false, brandServiceStepsList: action.result
      };

    case GET_BRAND_SERVICE_STEP_BY_ID_SUCCESS:
      return {
        ...state, loading: false, loaded: true, error: false, brandServiceStepData: action.result
      };

    case ADD_BRAND_SERVICE_STEP_SUCCESS:
    case UPDATE_BRAND_SERVICE_STEP_SUCCESS:
    case DELETE_BRAND_SERVICE_STEP_SUCCESS:
    case SORT_BRAND_SERVICE_STEPS_SUCCESS:
      return {
        ...state, loading: false, loaded: true, error: false
      };

    case GET_ORDER_TYPE_MASTERS_SUCCESS:
      return {
        ...state, loading: false, loaded: true, error: false, orderTypeMasterList: action.result
      };

    case GET_REVENUE_CENTER_MASTERS_SUCCESS:
      return {
        ...state, loading: false, loaded: true, error: false, revenueCenterMasterList: action.result
      };

    case GET_JOB_TYPES_SUCCESS:
      return {
        ...state, loading: false, loaded: true, error: false, jobTypesList: action.result
      };

    case GET_SERVICE_STEP_RULE_TYPES_SUCCESS:
      return {
        ...state, loading: false, loaded: true, error: false, serviceStepRuleTypesList: action.result
      };

    case GET_SERVICE_STEP_INTERACTION_TYPES_SUCCESS:
      return {
        ...state, loading: false, loaded: true, error: false, serviceStepInteractionTypesList: action.result
      };

    case GET_BRAND_STORES_SUCCESS:
      return {
        ...state, loading: false, loaded: true, error: false, storesList: action.result
      };

    case GET_BRAND_SERVICE_STEPS_FAILURE:
    case GET_BRAND_SERVICE_STEP_BY_ID_FAILURE:
    case ADD_BRAND_SERVICE_STEP_FAILURE:
    case UPDATE_BRAND_SERVICE_STEP_FAILURE:
    case DELETE_BRAND_SERVICE_STEP_FAILURE:
    case SORT_BRAND_SERVICE_STEPS_FAILURE:
    case GET_ORDER_TYPE_MASTERS_FAILURE:
    case GET_REVENUE_CENTER_MASTERS_FAILURE:
    case GET_JOB_TYPES_FAILURE:
    case GET_SERVICE_STEP_RULE_TYPES_FAILURE:
    case GET_SERVICE_STEP_INTERACTION_TYPES_FAILURE:
    case GET_BRAND_STORES_FAILURE:
      return {
        ...state, loading: false, loaded: true, error: true
      };

    default:
      return state;
  }
};

export const getBrandServiceStepsByBrandId = brandId => ({
  types: [GET_BRAND_SERVICE_STEPS_REQUESTED, GET_BRAND_SERVICE_STEPS_SUCCESS, GET_BRAND_SERVICE_STEPS_FAILURE],
  promise: client => client.get(`getBrandServiceStepsByBrandId/${brandId}`),
});

export const getBrandServiceStepById = brandServiceStepId => ({
  types: [GET_BRAND_SERVICE_STEP_BY_ID_REQUESTED, GET_BRAND_SERVICE_STEP_BY_ID_SUCCESS, GET_BRAND_SERVICE_STEP_BY_ID_FAILURE],
  promise: client => client.get(`getBrandServiceStepById/${brandServiceStepId}`),
});

export const addBrandServiceStep = data => ({
  types: [ADD_BRAND_SERVICE_STEP_REQUESTED, ADD_BRAND_SERVICE_STEP_SUCCESS, ADD_BRAND_SERVICE_STEP_FAILURE],
  promise: client => client.post('addBrandServiceStep', { data }),
});

export const updateBrandServiceStep = data => ({
  types: [UPDATE_BRAND_SERVICE_STEP_REQUESTED, UPDATE_BRAND_SERVICE_STEP_SUCCESS, UPDATE_BRAND_SERVICE_STEP_FAILURE],
  promise: client => client.post('updateBrandServiceStep', { data }),
});

export const deleteBrandServiceStep = brandServiceStepId => ({
  types: [DELETE_BRAND_SERVICE_STEP_REQUESTED, DELETE_BRAND_SERVICE_STEP_SUCCESS, DELETE_BRAND_SERVICE_STEP_FAILURE],
  promise: client => client.post(`deleteBrandServiceStep/${brandServiceStepId}`),
});

export const sortBrandServiceSteps = data => ({
  types: [SORT_BRAND_SERVICE_STEPS_REQUESTED, SORT_BRAND_SERVICE_STEPS_SUCCESS, SORT_BRAND_SERVICE_STEPS_FAILURE],
  promise: client => client.post('sortBrandServiceSteps', { data }),
});

export const getOrderTypeMastersByBrandId = brandId => ({
  types: [GET_ORDER_TYPE_MASTERS_REQUESTED, GET_ORDER_TYPE_MASTERS_SUCCESS, GET_ORDER_TYPE_MASTERS_FAILURE],
  promise: client => client.get(`getOrderTypeMasterByBrandId/${brandId}`),
});

export const getRevenueCenterMastersByBrandId = brandId => ({
  types: [GET_REVENUE_CENTER_MASTERS_REQUESTED, GET_REVENUE_CENTER_MASTERS_SUCCESS, GET_REVENUE_CENTER_MASTERS_FAILURE],
  promise: client => client.get(`getRevenueCenterMasterByBrandId/${brandId}`),
});

export const getJobTypes = () => ({
  types: [GET_JOB_TYPES_REQUESTED, GET_JOB_TYPES_SUCCESS, GET_JOB_TYPES_FAILURE],
  promise: client => client.get('getJobTypes'),
});

export const getServiceStepRuleTypes = () => ({
  types: [GET_SERVICE_STEP_RULE_TYPES_REQUESTED, GET_SERVICE_STEP_RULE_TYPES_SUCCESS, GET_SERVICE_STEP_RULE_TYPES_FAILURE],
  promise: client => client.get('getServiceStepRuleTypes'),
});

export const getServiceStepInteractionTypes = () => ({
  types: [GET_SERVICE_STEP_INTERACTION_TYPES_REQUESTED, GET_SERVICE_STEP_INTERACTION_TYPES_SUCCESS, GET_SERVICE_STEP_INTERACTION_TYPES_FAILURE],
  promise: client => client.get('getServiceStepInteractionTypes'),
});

export const getBrandStores = brandId => ({
  types: [GET_BRAND_STORES_REQUESTED, GET_BRAND_STORES_SUCCESS, GET_BRAND_STORES_FAILURE],
  promise: client => client.get(`getStoresByBrandId/${brandId}`),
});
